import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { AuthContext } from '../App';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

export default function VotingSection() {
  const { user } = useContext(AuthContext);
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [permissionDenied, setPermissionDenied] = useState(false);

  const fetchCandidates = async () => {
    try {
      setLoading(true);
      setPermissionDenied(false);
      const response = await axios.get('/voting/candidates', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setCandidates(response.data);
    } catch (error) {
      console.error('Error fetching candidates:', error);
      if (error?.response?.status === 403) {
        setPermissionDenied(true);
      }
      setCandidates([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchCandidates();
    } else {
      setCandidates([]);
      setPermissionDenied(false);
      setLoading(false);
    }
  }, [user]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Votazioni in corso</CardTitle>
        <CardDescription>Esprimi il tuo voto sui candidati</CardDescription>
      </CardHeader>
      <CardContent>
        {loading ? (
          <p className="text-sm text-gray-600">Caricamento...</p>
        ) : permissionDenied ? (
          <p className="text-red-600 text-sm">Permessi mancanti per esprimere il voto.</p>
        ) : candidates.length === 0 ? (
          <p className="text-sm text-gray-600">Nessun membro attualmente sottoposto a votazione</p>
        ) : (
          <div className="space-y-3">
            {candidates.map((candidate, index) => (
              <div key={candidate.id}>
                {index > 0 && <div className="border-t border-gray-200 my-3" />}
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="font-semibold mb-1">
                      {candidate.first_name} {candidate.last_name}
                    </h4>
                    {candidate.job_title && (
                      <p className="text-sm text-gray-600">{candidate.job_title}</p>
                    )}
                  </div>
                  <div>
                    {candidate.has_voted ? (
                      <span className="text-sm text-gray-600">✓ Votato</span>
                    ) : (
                      <Link to={`/vote/${candidate.id}`}>
                        <Button size="sm" className="bg-black text-white hover:bg-gray-800">
                          Vota
                        </Button>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
